function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import JSError from '@seudev/js-error';
export var formatDate = function formatDate(date, options, lang) {
  var i18n = useI18n();
  var language = lang ? lang : i18n.lang;

  if (date instanceof Date) {
    return date.toLocaleDateString(language, options || {});
  } else if (date instanceof DateTime) {
    return date.setLocale(language).toLocaleString(options || {});
  }
};

var addLang = function addLang(lang, state, setState, messagesProvider) {
  var langs = state.langs,
      messages = state.messages;

  if (!messagesProvider) {
    return new Promise(function (resolve, reject) {
      reject(new JSError({
        name: "X-i18n",
        message: "Not found messages provider."
      }));
    });
  }

  return messagesProvider(lang).then(function (data) {
    var _extends2;

    setState(_extends({}, state, {
      lang: lang,
      langs: langs.includes(lang) ? langs : [].concat(langs, [lang]),
      messages: _extends({}, messages, (_extends2 = {}, _extends2[data["default"].id] = data["default"].messages, _extends2))
    }));
  })["catch"](function (ex) {
    throw new JSError({
      name: "X-i18n",
      message: "Cannot load the messages of lang: " + lang,
      data: {
        lang: lang
      }
    }, ex);
  });
};

var buildSetLang = function buildSetLang(state, setState, messagesProvider) {
  return function (lang) {
    return new Promise(function (resolve, reject) {
      if (state.messages[lang] === undefined) {
        addLang(lang, state, setState, messagesProvider).then(function () {
          return resolve();
        })["catch"](function (e) {
          return reject(e);
        });
      } else if (state.lang !== lang) {
        setState(_extends({}, state, {
          lang: lang
        }));
        resolve();
      }
    });
  };
};

var buildTryUseNavigatorLang = function buildTryUseNavigatorLang(langs, setLang) {
  return function () {
    var userLang = navigator.language || navigator.userLanguage;
    return new Promise(function (resolve, reject) {
      if (langs.includes(userLang)) {
        setLang(userLang).then(function () {
          return resolve();
        })["catch"](function (e) {
          return reject(e);
        });
      } else {
        reject("Unsupported lang: " + userLang);
      }
    });
  };
};

export var I18nContext = createContext();
export var useI18n = function useI18n() {
  return useContext(I18nContext);
};
export var getNestedValue = function getNestedValue(obj, key, defaultValue) {
  if (obj != null) {
    key = key.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    key = key.replace(/^\./, ''); // strip a leading dot

    var keys = key.split('.');

    for (var _iterator = _createForOfIteratorHelperLoose(keys), _step; !(_step = _iterator()).done;) {
      var k = _step.value;
      obj = obj[k];

      if (obj == null) {
        break;
      }
    }
  }

  return obj == null ? defaultValue : obj;
};
export var getTemplate = function getTemplate(id, defaultTemplate) {
  var _useI18n = useI18n(),
      lang = _useI18n.lang,
      fallback = _useI18n.fallback,
      messages = _useI18n.messages;

  try {
    if (id == null) {
      if (defaultTemplate == null) {
        throw new JSError("The id must be not null.");
      }

      return defaultTemplate;
    }

    var template = null;
    var ids = id instanceof Array ? id : [id];

    for (var _iterator2 = _createForOfIteratorHelperLoose(ids), _step2; !(_step2 = _iterator2()).done;) {
      var key = _step2.value;
      template = getNestedValue(messages[lang], key);

      if (template == null) {
        template = getNestedValue(messages[fallback], key);
      }

      if (template != null) {
        break;
      }
    }

    if (template == null && defaultTemplate == null) {
      throw new JSError("Not found template for the id: \"" + id + "\", in the language" + (lang === fallback ? " \"" + lang + "\"" : "s \"" + lang + "\" and \"" + fallback + "\"") + ".");
    }

    return template || defaultTemplate;
  } catch (ex) {
    throw new JSError({
      name: "MessageError",
      message: "Cannot get the template: \"" + id + "\".",
      data: {
        id: id,
        lang: {
          current: lang,
          fallback: fallback
        },
        defaultTemplate: defaultTemplate
      }
    }, ex);
  }
};
export var interpolate = function interpolate(template, params) {
  if (params === void 0) {
    params = {};
  }

  var _useI18n2 = useI18n(),
      getMessage = _useI18n2.getMessage,
      formatDate = _useI18n2.formatDate;

  try {
    params.getMessage = getMessage;
    params.formatDate = formatDate;
    var names = Object.keys(params);
    var values = Object.values(params);
    names.push('params');
    values.push(params);

    var message = _construct(Function, names.concat(["return `" + template + "`;"])).apply(void 0, values);

    return message;
  } catch (ex) {
    throw new JSError({
      name: "MessageError",
      message: "Cannot interpolate the message: \"" + template + "\".",
      data: {
        template: template,
        params: params
      }
    }, ex);
  }
};
export var getMessage = function getMessage(id, params, defaultMessage) {
  if (params === void 0) {
    params = {};
  }

  try {
    var template = getTemplate(id, defaultMessage);

    if (template instanceof Array) {
      return template.map(function (t) {
        return interpolate(t, params);
      });
    }

    return interpolate(template, params);
  } catch (ex) {
    console.error(new JSError({
      name: "MessageError",
      message: "Cannot get the message with the id: \"" + id + "\".",
      data: {
        id: id,
        params: params,
        defaultMessage: defaultMessage
      }
    }, ex));
    return "";
  }
};

var I18n = function I18n(_ref) {
  var _messages;

  var lang = _ref.lang,
      tryUseNavigatorLang = _ref.tryUseNavigatorLang,
      _ref$config = _ref.config,
      fallback = _ref$config.fallback,
      langs = _ref$config.langs,
      messagesProvider = _ref$config.messagesProvider,
      children = _ref.children;

  var _useState = useState({
    lang: fallback.id,
    fallback: fallback.id,
    langs: langs,
    messages: (_messages = {}, _messages[fallback.id] = fallback.messages, _messages)
  }),
      state = _useState[0],
      setState = _useState[1];

  var setLang = buildSetLang(state, setState, messagesProvider);

  var _tryUseNavigatorLang = buildTryUseNavigatorLang(state.langs, setLang);

  useEffect(function () {
    if (lang && state.lang !== lang) {
      setLang(lang);
    }
  }, [lang]);
  useEffect(function () {
    if (tryUseNavigatorLang) {
      _tryUseNavigatorLang();
    }
  }, [tryUseNavigatorLang]);

  var i18n = _extends({}, state, {
    setLang: setLang,
    tryUseNavigatorLang: _tryUseNavigatorLang,
    getMessage: getMessage,
    formatDate: formatDate
  });

  return /*#__PURE__*/React.createElement(I18nContext.Provider, {
    value: i18n
  }, children);
};

I18n.propTypes = process.env.NODE_ENV !== "production" ? {
  config: PropTypes.shape({
    fallback: PropTypes.shape({
      id: PropTypes.string,
      messages: PropTypes.object
    }).isRequired,
    langs: PropTypes.arrayOf(PropTypes.string).isRequired,
    messagesProvider: PropTypes.func.isRequired
  }),
  lang: PropTypes.string,
  tryUseNavigatorLang: PropTypes.bool
} : {};
I18n.defaultValues = {
  tryUseNavigatorLang: false
};
export default I18n;